export default function CaliforniaFinalCTA() {
  return (
    <section className="bg-[#0F2240] py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-5">
          Ready to Get Your Passport Fast?
        </h2>
        <p className="text-white/70 text-lg max-w-xl mx-auto mb-10 leading-relaxed">
          Whether you are in Los Angeles, San Francisco, San Diego, Sacramento, or anywhere in between — we help California travelers get their passports on time. Start your application in minutes.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Passport <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 border border-white/30 text-white font-semibold text-base px-8 py-4 rounded-md transition-all hover:bg-white/10 whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>877-253-0084
          </a>
        </div>
        <p className="text-white/40 text-sm mt-8">
          A+ BBB Rated &bull; Registered U.S. Department of State Courier &bull; 20+ Years of Service
        </p>
      </div>
    </section>
  );
}